import React, { Children } from "react";
import Footer from "./Footer";
import Header from "./Header";
import SidebarMenu from "./Sidebar";
import index from "./index.css";

const Layout = ({ children }) => {
  return (
    <div className="main-wrapper">
       
     <div className="left-menu">
      <SidebarMenu />
      </div>
      <Header />
      <div className="main-content">
     <div className="page-content">
      {children}
      </div>
      <Footer />
      </div>
      
    </div>
  );
};

export default Layout;
